import { createContext as o, use as p } from "react";
import { jsx as u } from "react/jsx-runtime";
var e = o(null);
e.displayName = "AppRouterContext";
var i = ({ router: r, children: t }) => /* @__PURE__ */ u(e, {
  value: r,
  children: t
}), s = () => {
  const r = p(e);
  if (!r) throw new Error("useAppRouter Hook must be used within an AppRouterProvider");
  return r;
};
export {
  i as AppRouterProvider,
  s as useAppRouter
};

//# sourceMappingURL=AppRouterProvider.js.map